import axios from 'axios';
import { trackEvent } from './analytics';

const mapEndpointToEvent = (endpoint) => {
    if (endpoint.includes('/api/page/update')) return 'feedback_submitted';
    if (endpoint.includes('/api/page/add')) return 'page_created';
    if (endpoint.includes('/api/page/edit')) return 'page_updated';
    if (endpoint.includes('/api/auth/sign-in')) return 'sign_in_completed';
    if (endpoint.includes('/api/auth/sign-up')) return 'sign_up_completed';
    if (endpoint.includes('/api/payment/customer-portal')) return 'customer_portal_opened';
    if (endpoint.includes('/api/emails/add')) return 'newsletter_subscribed';
    if (endpoint.includes('/api/contact/send-message')) return 'contact_message_sent';
    return null;
};

const bodyRequest = (type, endpoint, body, files, uploadProgress) => {
    return new Promise((resolve, reject) => {
        let data;

        if (files) {
            data = new FormData();

            Object.keys(body).forEach((key) => {
                data.append(key, body[key]);
            });

            Object.keys(files).forEach((key) => {
                data.append(key, files[key]);
            });
        } else {
            data = body;
        }

        axios[type](endpoint, data, {
            headers: { Authorization: `Bearer ${localStorage.getItem('identity')}` },
            onUploadProgress:
                uploadProgress && typeof uploadProgress === 'function' ? uploadProgress : undefined,
        })
            .then((result) => {
                if (result.token) localStorage.setItem('identity', result.token);
                const eventName = mapEndpointToEvent(endpoint);
                if (eventName) {
                    trackEvent(eventName, { endpoint });
                }
                resolve(result.data);
            })
            .catch((err) => {
                if (err && err.response && err.response.data && err.response.data.error) {
                    err.description = err.response.data.error;
                    reject(err);
                } else {
                    reject(err);
                }
            });
    });
};

const api = {
    get: (endpoint) => {
        return new Promise((resolve, reject) => {
            axios
                .get(endpoint, {
                    headers: { Authorization: `Bearer ${localStorage.getItem('identity')}` },
                })
                .then((result) => resolve(result.data))
                .catch((err) => {
                    if (err && err.response && err.response.data && err.response.data.error) {
                        err.description = err.response.data.error;
                        reject(err);
                    } else {
                        reject(err);
                    }
                });
        });
    },

    post: (endpoint, body, files, uploadProgress) =>
        bodyRequest('post', endpoint, body, files, uploadProgress),
    put: (endpoint, body, files, uploadProgress) =>
        bodyRequest('put', endpoint, body, files, uploadProgress),
    patch: (endpoint, body, files, uploadProgress) =>
        bodyRequest('patch', endpoint, body, files, uploadProgress),
    delete: (endpoint, body, files, uploadProgress) =>
        bodyRequest('delete', endpoint, body, files, uploadProgress),
};

export default api;
